import type { AnimalEventType } from "../types";

const LABELS: Record<AnimalEventType, string> = {
  animal_registered: "Registro inicial",
  animal_purchased: "Compra",
  lot_cost_allocated: "Costo asignado al lote",
  stage_transitioned: "Cambio de etapa",
  lot_changed: "Cambio de lote",
  first_calving_recorded: "Primer parto",
  calving_recorded: "Parto",
  dry_off_recorded: "Secado",
  depreciation_accrued: "Depreciación mensual",
  appreciation_accrued: "Apreciación mensual",
  animal_died: "Muerte",
  animal_culled: "Descarte",
  animal_sold: "Venta",
  event_corrected: "Corrección",
};

export function eventLabel(eventType: string): string {
  return LABELS[eventType as AnimalEventType] ?? "Evento";
}
